export const campaignConfig = {
    campaignListConfig: 'campaign_devapp', // campaign_devapp
    campaignSms: 'campaign_ksam_sms_uniquelink',
};

export const dashboardConfig = {
    mainDashboard: '',
};

export const categoryConfig = {
    menuCategory: 'menu_devapp',
    menuSms: 'menu_ksam_sms_uniquelink'
};

export const historyConfig = {
    purchase: 'purchase',
};
